import { fg } from '@atlaskit/platform-feature-flags';
import { type AlphaExtendedThinkingMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const getAlphaExtendedThinkingMode = (
	reasoningMode: string,
): AlphaExtendedThinkingMode | undefined => {
	if (!fg('rovo_chat_marathon_orchestrator_reasoning_modes')) {
		return undefined;
	}

	switch (reasoningMode) {
		case 'think-deeper-marathon':
			return 'MARATHON';
		case 'think-deeper-orchestrator':
			return 'LONG_HORIZON';
		default:
			return undefined;
	}
};
